import React, { useId, useState } from "react";
import { ChevronDown } from "react-bootstrap-icons";

const linkPattern =
  /([\w.+-]+@[\w-]+(?:\.[\w-]+)*\w|\+1 \(\d{3}\) \d{3}-\d{4})/g;

const linkify = (text) =>
  text.split(linkPattern).map((part, index) => {
    if (index % 2 === 0) return part;
    const href = part.includes("@")
      ? `mailto:${part}`
      : `tel:+${part.replace(/\D/g, "")}`;
    return (
      <a key={index} href={href}>
        {part}
      </a>
    );
  });

const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const id = useId();

  return (
    <div className={`faq-item${open ? " is-open" : ""}`}>
      <h3 className="faq-item__heading">
        <button
          type="button"
          id={`${id}-question`}
          className="faq-item__question"
          aria-expanded={open}
          aria-controls={`${id}-answer`}
          onClick={() => setOpen(!open)}
        >
          <span>{question}</span>
          <ChevronDown className="faq-item__chevron" aria-hidden="true" />
        </button>
      </h3>
      <div
        id={`${id}-answer`}
        role="region"
        aria-labelledby={`${id}-question`}
        className="faq-item__panel"
      >
        <div className="faq-item__panel-inner">
          <p>{linkify(answer)}</p>
        </div>
      </div>
    </div>
  );
};

export default FaqItem;
